//导入两个文件
import en from "./en";
import zh from "./zh";
export default {
  en: en,
  zh: zh,
};
